module.exports = __webpack_public_path__ + "img/logo.ccb7beb8.png";